// extracted by mini-css-extract-plugin
export default {"container":"auth-redirect_container__8Ih+q"};